import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { StatusPill } from "../../components/Pills";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function AdminStations() {
  const [stations, setStations] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: "", address: "", x: 0.5, y: 0.5, power_source: "solar+battery", capacity_kw: 200,
  });

  const refresh = () => api.get("/stations").then(({ data }) => setStations(data));
  useEffect(() => { refresh(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/stations", { ...form, capacity_kw: Number(form.capacity_kw), x: Number(form.x), y: Number(form.y) });
      toast.success("Station onboarded");
      setOpen(false); refresh();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="bin-label">REGISTRY</div>
          <h1 className="text-3xl font-black tracking-tighter mt-1">Stations</h1>
        </div>
        <button data-testid="onboard-station-btn" onClick={() => setOpen(true)} className="bin-btn bin-btn-primary inline-flex items-center gap-2">
          <Plus className="w-4 h-4" /> Onboard station
        </button>
      </div>

      <div className="bin-card overflow-hidden">
        <table className="w-full text-xs font-mono">
          <thead className="bg-[#18181b]">
            <tr className="text-left text-zinc-500">
              <th className="px-4 py-3">Name</th>
              <th>Address</th>
              <th>Source</th>
              <th>Capacity</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {stations.map((s) => (
              <tr key={s.id} className="border-t border-zinc-800">
                <td className="px-4 py-3 font-bold text-white">{s.name}</td>
                <td>{s.address}</td>
                <td className="uppercase">{s.power_source}</td>
                <td>{s.capacity_kw}kW</td>
                <td><StatusPill status={s.status} /></td>
                <td className="text-zinc-500">{new Date(s.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/70 grid place-items-center z-50 p-4">
          <form onSubmit={create} className="bin-card-elevated p-6 w-full max-w-md" data-testid="onboard-form">
            <div className="bin-label mb-3">ONBOARD</div>
            <h2 className="text-xl font-bold mb-4">New Station</h2>

            {[
              ["Name", "name", "text"],
              ["Address", "address", "text"],
              ["Power source", "power_source", "text"],
              ["Capacity (kW)", "capacity_kw", "number"],
              ["Map X (0-1)", "x", "number"],
              ["Map Y (0-1)", "y", "number"],
            ].map(([label, key, type]) => (
              <div key={key} className="mb-3">
                <label className="bin-label">{label}</label>
                <input
                  data-testid={`station-${key}`}
                  type={type}
                  step="0.01"
                  required
                  value={form[key]}
                  onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                  className="w-full mt-1 bg-[#0f0f11] border border-zinc-800 rounded px-3 py-2 text-sm font-mono"
                />
              </div>
            ))}

            <div className="flex gap-2 mt-4">
              <button type="submit" className="bin-btn bin-btn-primary flex-1">Create</button>
              <button type="button" onClick={() => setOpen(false)} className="bin-btn">Cancel</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
